import React from 'react';
import PropTypes from 'prop-types';
import TaxFlowChartButton from './TaxFlowChartButton';

const TaxFlowChartSectionOne = (props) => {
  const yesButtonActive = props.section > 0 && props.eligible ? 'active' : '';
  const noButtonActive = props.section > 0 && !props.eligible ? 'active' : '';
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1">
          <h1>Am I Eligible to File as a Sole Proprietor?</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 tax-flow-chart-desk-col visible-xs">
          <img src={`${props.cdnURL}/images/TaxFlowChart/question1-2x.png`} alt="Desk" />
        </div>
      </div>
      {props.section === 0 &&
        <div className="row">
          <div className="col-sm-2 col-sm-offset-5 hidden-xs">
            <img src={props.iconSrc} alt="User Icon" />
          </div>
        </div>
      }
      <div className="row tax-flow-chart-question-one">
        <div className="col-sm-6 col-sm-offset-3 tax-flow-chart-pipe">
          <p>
            Do you own your own business or have a freelance position
            that qualifies as a sole proprietorship?
          </p>
        </div>
      </div>
      <div className="row tax-flow-chart-answer-one">
        <TaxFlowChartButton
          colClasses="col-sm-2 col-sm-offset-1 tax-flow-chart-button-col-left"
          buttonClasses={`tax-flow-chart-button-yes ${yesButtonActive}`}
          onClick={() => props.updateSection(1)}
          text="Yes"
        />
        <div className="col-sm-6 tax-flow-chart-desk-col hidden-xs">
          <img src={`${props.cdnURL}/images/TaxFlowChart/question1-2x.png`} alt="Desk" />
        </div>
        <TaxFlowChartButton
          colClasses="col-sm-2 tax-flow-chart-button-col-right"
          buttonClasses={`${noButtonActive}`}
          onClick={() => props.updateSection(1, false)}
          text="No"
        />
      </div>
    </React.Fragment>
  );
};

TaxFlowChartSectionOne.propTypes = {
  section: PropTypes.number.isRequired,
  eligible: PropTypes.bool.isRequired,
  updateSection: PropTypes.func.isRequired,
  iconSrc: PropTypes.string.isRequired,
  cdnURL: PropTypes.string.isRequired,
};

export default TaxFlowChartSectionOne;



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionOne.jsx